import { createReducer, on } from '@ngrx/store';
import { getCampaignContent, getCampaignSettings, setCampaignContent, setCampaignSettings } from '../actions/campaign.actions';
import { CampaignContentState } from '../models/campaign-models';
import { CampaignSettingsState } from '../models/assessment-models';

export const initialCampaignContentState: CampaignContentState = {
  content: [],
};
export const contentReducer = createReducer(
  initialCampaignContentState,
  on(setCampaignContent, (state, { content }) => ({
    ...state,
    content: content,
  })),
  on(getCampaignContent, (state, { content }) => ({
    ...state,
    content: content,
  })),
);

export const initialCampaignSettingsState: CampaignSettingsState = {
  showExternalIdField: false
};

export const campaignSettingsReducer = createReducer(
  initialCampaignSettingsState,
  on(setCampaignSettings, (state, { showExternalIdField }) => ({
    ...state,
    showExternalIdField: showExternalIdField
  })),
  on(getCampaignSettings, (state, { showExternalIdField }) => ({
    ...state,
    showExternalIdField: showExternalIdField
  }))
);
